import { calculatePercentage } from '@/lib/collection/math-utils'
import { withPercentage } from '@/lib/string/string-utils'
import { CHART_COLORS } from '@/lib/ui/variants'

import type { ChartSegment } from './types'

export const segmentTotal = (segments: ChartSegment[]): number =>
  segments.reduce((total, { value }) => total + value, 0)

export const segmentFill = ({ color }: ChartSegment): string => color ?? CHART_COLORS.unscored

export const segmentShare = ({ value }: ChartSegment, total: number): string =>
  withPercentage(calculatePercentage({ amount: value, total }))
